module.exports = __webpack_public_path__ + "img/woolarge.18c5a5f0.jpg";